var $ = require('jquery');

$(function () {

    $('.external-search-box').each(function () {
        var t = $(this);
        t.find('button.search-button').on('click', function() {
            var searchUrl = t.data('search-url');
            var searchParam = t.data('search-parameter');
            var searchValue = t.find('.searchbox__input').val();
            var openInNewWindow = (t.data('new-window') === "True") ? "_blank" : "_self";
            externalSearch(searchUrl, searchParam, searchValue, openInNewWindow);
        });
    });

    function externalSearch(url, keyword, value, newWindow) {
        var querystring = decodeURIComponent((url + "?" + keyword + "=" + value).replace(/\+/g, " "));
        window.open(querystring, newWindow);
    }
});
